import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Http } from "@angular/http";
import * as papa from "papaparse";


import config from "../../../config/config";


/**
 * Generated class for the ListadeSolicitacoesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-listade-solicitacoes',
  templateUrl: 'eclistade-solicitacoes.html',
})
export class ecListadeSolicitacoesPage {
  usuario: any;
  grupo: any;
  agenda:any;
  agendames:any;
  agendaFull:any;
  file:any;
  exportar=[];
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    private alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navParams: NavParams
  ) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.grupo = this.usuario.grupold;
    if (this.usuario.grupold == 2) {
      this.allSolicitacoes()
      this.mesAgenda()
    } else if(this.usuario.grupold == 3 || this.usuario.grupold == 5) {
      this.funcionariosSolicitacoes()
    }else{
      this.usuarioSolicitacoes()
      
    }
  } 
  allSolicitacoes(){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
    .get(config.urlAPI + "pesquisar/agendamentoespacocultural", {}) 
    .map(res => res.json())
    .toPromise()
    .then(res => {
      res.map((r)=>{ 
        if (r.status ==1) {
          r.status= 'Aguardando';
        }
        if (r.status ==2){
          r.status= 'Aceito';
        }
        if (r.status ==3){
          r.status= 'Recusado';
        }
        if (r.status ==4){
          r.status= 'Atendido';
        }
        
      })
      this.agenda = res;
      this.agendaFull=res;
      loading.dismiss();

    })
    .catch(error => { });
  }

  subirComprovante(event,id){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this.file = <File>event.target.files[0];
    const fd = new FormData();
    fd.append("image", this.file, this.file.name);
    this._http
      .post(config.urlAPI + "comprovante/espacoCultural/"+id, fd, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
      loading.dismiss();

        let alert = this.alertCtrl.create({
          title: "",
          subTitle: `Imagem salva com sucesso`,
          buttons: [
            {
              text: "OK",
              handler: data => {
                this.ionViewDidLoad()
              }
            }
          ],
          enableBackdropDismiss: false
      })
      alert.present();

    }).catch(error => {
      loading.dismiss();
      let alert = this.alertCtrl.create({
        title: "",
        subTitle: `Ocorreu um erro tente novamente mais tarde`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              this.ionViewDidLoad()
            }
          }
        ],
        enableBackdropDismiss: false
    })
    alert.present();

      });
  }
  funcionariosSolicitacoes(){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
    .get(config.urlAPI + "pesquisar/agendamentoespacocultural/funcionario/"+this.usuario.id, {}) 
    .map(res => res.json())
    .toPromise()
    .then(res => {
      res.map((r)=>{
        if (r.status ==1) {
          r.status= 'Aguardando';
        }
        if (r.status ==2){
          r.status= 'Aceito';
        }
        if (r.status ==3){
          r.status= 'Recusado';
        } if (r.status ==4){
          r.status= 'Finalizado';
        }
        
      })
      this.agenda = res;
      loading.dismiss();

    })
    .catch(error => { });
  }
  usuarioSolicitacoes(){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
    .get(config.urlAPI + "pesquisar/agendamentoespacocultural/user/"+this.usuario.id, {}) 
    .map(res => res.json())
    .toPromise()
    .then(res => {
      res.map((r)=>{
        if (r.status ==1) {
          r.status= 'aguardando';
        }
        if (r.status ==2){
          r.status= 'Aceito';
        }
        if (r.status ==3){
          r.status= 'Recusado';
        }
        
      })
      this.agenda = res;
      loading.dismiss();

    })
    .catch(error => { });
  }
  recusarSolicotacao(item){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    let env={
      id:item.id,
      status:3,
      nome:item.solicitante.nome,
      email:item.solicitante.email

    }
    this._http
    .post(config.urlAPI + "agendaespacocultural/status",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      loading.dismiss()
      let alert = this.alertCtrl.create({
        title: "",
        subTitle: `${res.mnsg}`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              this.ionViewDidLoad()
            }
          }
        ],
        enableBackdropDismiss: false

      });
      alert.present();
    })
    .catch(error => { 
    });
  }
  aceitarSolicotacao(item){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();

    let env={
      id:item.id,
      status:2,
      nome:item.solicitante.nome,
      email:item.solicitante.email

    }
    this._http
    .post(config.urlAPI + "agendaespacocultural/status",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      loading.dismiss()
      let alert = this.alertCtrl.create({
        title: "",
        subTitle: `${res.mnsg}`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              this.ionViewDidLoad()
            }
          }
        ],
        enableBackdropDismiss: false

      });
      alert.present();
    })
    .catch(error => { 
      console.log(error)
    });
  }
  atendidoSolicotacao(item){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();

    let env={
      id:item.id,
      status:4,
      nome:item.solicitante.nome,
      email:item.solicitante.email

    }
    this._http
    .post(config.urlAPI + "agendaespacocultural/status",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      loading.dismiss()
      let alert = this.alertCtrl.create({
        title: "",
        subTitle: `Para abrir o termos clique em ok`,
        buttons: [
          {
            text: "OK",
            handler: data => {
              window.open('https://backend.sistema.sintufrj.org.br/storage/'+res.mnsg, '_blank');
              this.ionViewDidLoad()
            }
          }
        ],
        enableBackdropDismiss: false

      });
      alert.present();
    })
    .catch(error => { 
      console.log(error)
    });
  }
  mesAgenda(){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
    .get(config.urlAPI + "pesquisar/agendamentoespacocultural/mes", {}) 
    .map(res => res.json())
    .toPromise()
    .then(res => {
      res.map((r)=>{ 
        if (r.status ==1) {
          r.status= 'aguardando';
        }
        if (r.status ==2){
          r.status= 'Aceito';
        }
        if (r.status ==3){
          r.status= 'Recusado';
        }
        
      })
      this.agendames = res;
      loading.dismiss();

    })
    .catch(error => { });
  }
  export(data){
    this.exportar=[]
    let env = {
      max:'',
      min:''

    };
    if (data.month < 10) {
      env.max = data.year+"-0"+data.month+"-31";
      env.min = data.year+"-0"+data.month+"-01";

    }else{
      env.max = data.year+"-"+data.month+"-31";
      env.min = data.year+"-"+data.month+"-01";
    }
    this.agendames.forEach(a => {

      if (a.inform_agenda.dia <= env.max && a.inform_agenda.dia >= env.min) {
        this.exportar.push(a)
      }
    });
    if (this.exportar.length) {
      this.extractData()
    }else{
      let alert = this.alertCtrl.create({
        title: "",
        subTitle: 'Não há dados para exportar na data solicitada',
        buttons: [
          {
            text: "OK",
            handler: data => {
            }
          }
        ]
      });
      alert.present();
    }
  }
  private extractData() {
    let teste = [];
    for (let f = 0; f < this.exportar.length; f++) {

      let element = {
        nome: this.exportar[f].solicitante.nome,
        siape: this.exportar[f].solicitante.siape,
        dia: this.exportar[f].inform_agenda.dia,
        sede: this.exportar[f].inform_agenda.local.nome,
        horarioInicio: this.exportar[f].inform_agenda.horas.inicio,
        horarioFim: this.exportar[f].inform_agenda.horas.fim,
        servico: this.exportar[f].inform_agenda.servico.nome,
        status: this.exportar[f].status,
        resumo: this.exportar[f].resumo,

      };
      var obj = Object.assign({}, element, this.exportar[f].informes);  
      teste.push(obj);
    }
    this.downloadCSV(teste);
  }

  downloadCSV(env) {
    let csv = papa.unparse(env);
    var blob = new Blob([csv]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "atendimentos.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  abrirResumo(text){
    let alert = this.alertCtrl.create({
      title: "",
      subTitle: `${text}`,
      buttons: [
        {
          text: "OK",
          handler: data => {
          }
        }
      ]
    });
    alert.present();
  }
  initializeItems() {
    this.agenda = [];

    for (var i = 0; i < this.agendaFull.length; ++i) {
      var it = this.agendaFull[i];
      this.agenda.push(it);
    }
  }
  applyFilter(ev){
  this.initializeItems();


  const val = ev.target.value;
  if (val.length >= 2) {

    // if the value is an empty string don't filter the items
      if (val && val.trim() != "") {
        this.agenda = this.agenda.filter(item => {
          return (
            (item.solicitante.nome.toString().toLowerCase().indexOf(val.toLowerCase()) > -1 ||item.status.toString().toLowerCase().indexOf(val.toLowerCase()) > -1 ||item.inform_agenda.local.nome.toString().toLowerCase().indexOf(val.toLowerCase()) > -1 ||item.inform_agenda.servico.nome.toString().toLowerCase().indexOf(val.toLowerCase()) > -1 )
          );
        });
      } else {
        this.initializeItems();
      }
    }
  }
    
 
}



// WEBPACK FOOTER //
// ./src/pages/espaco-cultural/listade-solicitacoes/eclistade-solicitacoes.ts